/**
 * Handles all focus to anchor
 * @module ccExpMask to
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import 'jquery-mask-plugin';

// Expose the function as a jQuery plugin for ease of uses
export const PLUGIN_NAME = 'ccExpMask';
export const DEFAULTS = {
};

function setFormating($el) {
    if ($el.length) {
        $el.mask('00/00');
    }
}

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @see DEFAULTS
 */
export default function ccExpMask(el) {
    const $el = $(el);
    setFormating($el);
}

registerJQueryPlugin(PLUGIN_NAME, ccExpMask);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/cc-exp-mask.js